import axios from "axios";
import { HOST, ORIGIN, SERVER_URL } from "../config";
import { ApiFailMessageFilter } from "utils/apiFailMessageFilter";
import createAuthRefreshInterceptor from "axios-auth-refresh";
import Swal from "sweetalert2";

axios.defaults.baseURL = SERVER_URL;
axios.defaults.headers.common["Content-Type"] = "application/json";

const RefreshTokenEndpoint = "/sales/incentive/renew_token";

export const defaultHeaders = {
  "Access-Control-Allow-Origin": ORIGIN,
  // 'Host': window ? window.location.host : HOST
  // 'preserve_host': true
};

// Function that will be called to refresh authorization
const refreshAuthLogic = (failedRequest) => {
  // console.log("refreshAuthLogic", failedRequest);
  const refreshToken = localStorage.getItem("refreshToken");
  const clientId = JSON.parse(localStorage.getItem("clientId"));
  return axios
    .get(RefreshTokenEndpoint, {
      headers: {
        "Super-Authorization": refreshToken,
        "X-User-Id": clientId,
        ...defaultHeaders,
      },
    })
    .then((tokenRefreshResponse) => {
      // console.log("refreshAuthLogic res", tokenRefreshResponse);
      localStorage.setItem("token", tokenRefreshResponse.data.data);
      failedRequest.response.config.headers["Authorization"] =
        "Bearer " + tokenRefreshResponse.data.data;
      window.location.reload();
      return Promise.resolve();
    })
    .catch((error) => {
      localStorage.clear();
      Swal.fire({
        icon: "error",
        title: "You session expired, please login again.",
        confirmButtonText: "Okay",
      }).then(() => {
        window.location.replace("/login");
      });
    });
};

// Instantiate the interceptor
createAuthRefreshInterceptor(axios, refreshAuthLogic, {
  statusCodes: [401, 403],
  shouldRefresh: (error) => {
    const response = error?.response || {
      data: {},
      config: {},
      status: undefined,
    };
    const config = response?.config || {};
    const endpoint = config.url;
    const isRefreshTokenApi = RefreshTokenEndpoint === endpoint;
    return (
      (response.status === 401 && !isRefreshTokenApi) ||
      ["UE11011", "UE11012"].includes(response.data?.errorcode)
    );
  },
});

axios.interceptors.response.use(
  function (response) {
    // console.log("interceptor response", response);
    return response;
  },
  function (error) {
    if (error.response) {
      error.name = `API Error (${error.response.status})`;
    }
    if (error.message === "Network Error") {
      Swal.fire(error.message, "Check your connection!", "error");
    }
    const errorData = ApiFailMessageFilter(error);

    return Promise.reject({ ...errorData, errorObj: error });
  }
);

axios.interceptors.request.use(
  function (request) {
    return request;
  },
  function (error) {
    return Promise.reject(error);
  }
);

const AxiosService = function () {
  let Authorization = null;

  function addHeaders(userConfig) {
    const { params, headers = {}, timeout, ...restConfigs } = userConfig;
    let globalHeaders = {
      ...defaultHeaders,
    };
    const token = localStorage.getItem("token");
    if (token) {
      globalHeaders.Authorization = `Bearer ${token}`;
    }

    const { ...restParams } = params || {};
    return {
      ...restConfigs,
      headers: {
        ...globalHeaders,
        ...headers,
      },
      params: {
        ...restParams,
      },
      timeout,
      mode: "cors",
    };
  }

  function getAuthorizationToken() {
    return Authorization;
  }

  function setAuthorizationToken(token) {
    Authorization = token;
  }

  function resetAuthorizationToken() {
    Authorization = null;
  }

  function get(endPoint, userConfig = {}) {
    return axios.get(endPoint, addHeaders(userConfig));
  }

  function post(endPoint, params = {}, userConfig = {}) {
    return axios.post(endPoint, params, addHeaders(userConfig));
  }

  function put(endPoint, params = {}, userConfig = {}) {
    return axios.put(endPoint, params, addHeaders(userConfig));
  }

  function remove(endPoint, params = {}, userConfig = {}) {
    return axios.delete(endPoint, addHeaders(userConfig));
  }

  return {
    setAuthorizationToken,
    getAuthorizationToken,
    resetAuthorizationToken,
    get,
    post,
    put,
    remove,
  };
};

const axiosService = AxiosService();

export default axiosService;
